import React from "react";
import ArrowUpwardRoundedIcon from "@material-ui/icons/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@material-ui/icons/ArrowDownwardRounded";
import RemoveRoundedIcon from "@material-ui/icons/RemoveRounded";

const ChartLabel = ({
	title,
    skor,
	desc,
	type, // atas | bawah | rata
}) => {
	let icon;
	let color;
    let elTitle;
	if (type === "atas") {
		color = "indicator-chart";
		icon = <ArrowUpwardRoundedIcon />;
	} else if (type === "bawah") {
		color = "indicator-chart-red";
		icon = <ArrowDownwardRoundedIcon />;
	} else {
		color = "indicator-chart-abu";
		icon = <RemoveRoundedIcon />;
	}
    if(title) {
        elTitle =  <div className="title">{title}</div>;
    }
	return (
		<div className="label-chart">
			<div className={color}>{icon}</div>
			<div className="desc-chart">
				{elTitle}
				<div className="desc"><b style={{color: "#424242"}}>{skor} </b>{desc}</div>
			</div>
		</div>
	);
};

export default ChartLabel;
